import { useCallback } from 'react';
import { ConnectedSelectBox } from '@eti/form';
import { cx } from '@eti/styles';
import { formatLabel, handleSelectedOption } from '../../utils/selectBoxOptions';
import { screenReaderOnly } from '../../utils/styles';
import { useProductCardContext } from '../../context/ProductCardContext';
import { selectBoxStyles } from './styles';
import OptionsList from './OptionsList';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const CustomSelectBox = ({
  onModalOpen,
  onOptionClick,
  CustomLabel,
  CustomOptions,
  className
}) => {
  const {
    extraProps,
    productName
  } = useProductCardContext();
  const {
    formattedOptions,
    isValidationEnabled = false,
    selectBoxTestId,
    selectedOptions,
    setSelectedOptions,
    translation
  } = extraProps;
  const {
    allTravelersLabel,
    noTravelersLabel,
    placeholder,
    placeholderSelectedPlural,
    placeholderSelectedSingular,
    selectboxLabel,
    dropDownCloseInstruction
  } = translation;
  const hasLabel = Boolean(isValidationEnabled && selectboxLabel);
  const defaultLabel = hasLabel ? selectboxLabel : '';
  const formatSelectedOption = opts => {
    const label = formatLabel({
      selectedOptions: opts,
      allTravelersLabel,
      defaultPlaceholder: placeholder,
      placeholderSelectedSingular,
      placeholderSelectedPlural,
      noTravelersLabel
    });
    return /*#__PURE__*/_jsx("p", {
      children: label
    });
  };
  const normalizedValue = useCallback((newValue, prevVal) => {
    if (!newValue) {
      return selectedOptions;
    }
    const selectedOption = handleSelectedOption(formattedOptions, prevVal, newValue);
    if (selectedOption !== null && selectedOption !== void 0 && selectedOption.length) {
      setSelectedOptions(selectedOption);
      onModalOpen(selectedOption);
      return selectedOption;
    }
    setSelectedOptions(null);
    return null;
  }, [formattedOptions, onModalOpen, selectedOptions, setSelectedOptions]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      className: screenReaderOnly,
      id: "dropdown-close-instruction",
      tabIndex: -1,
      children: dropDownCloseInstruction
    }), /*#__PURE__*/_jsx(ConnectedSelectBox, {
      className: cx(selectBoxStyles, className),
      "data-testid": selectBoxTestId,
      formatSelectedOption: formatSelectedOption,
      isDisabled: !(formattedOptions !== null && formattedOptions !== void 0 && formattedOptions.length),
      isMultiple: true,
      label: CustomLabel ? /*#__PURE__*/_jsx(CustomLabel, {}) : defaultLabel,
      name: `${productName}.value`,
      normalize: normalizedValue,
      placeholder: placeholder,
      shouldMarkInputAsRequired: hasLabel,
      validationRuleName: productName,
      children: CustomOptions ? /*#__PURE__*/_jsx(CustomOptions, {
        formattedOptions: formattedOptions,
        onOptionClick: onOptionClick
      }) : /*#__PURE__*/_jsx(OptionsList, {
        formattedOptions: formattedOptions,
        onOptionClick: onOptionClick
      })
    })]
  });
};
export default CustomSelectBox;
//# sourceMappingURL=CustomSelectBox.js.map